<template>
  <div class="wrapper">
    <div class="contentModule">
      <div class="theme">
        <div>
          <div class="insuranceTheme">国内贸易信用险 - 填写信息</div>
          <div class="insuranceDescription"></div>
        </div>
      </div>
      <div class="section">
        <div class="customerIcon">
          <span class="icon"></span>
        </div>
        <div class="processProcedure" id="node-1" style="width: 15rem;">
          <div class="unit">
            <span>01</span>
            <span>投保人信息</span>
          </div>
        </div>
        <ul class="insureList">
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>投保人名称：</span>
            </div>
            <div class="sInfo" >
              <input type="text" placeholder="请输入投保人名称"  v-model="policyHolderInfo.companyName">
            </div>
          </li>
          <li class="address">
            <div class="tit">
              <span class="must">*</span>
              <span>注册地址：</span>
            </div>
            <div class="sInfo">
                  <textarea maxlength="200" placeholder="请填写注册地址"
                            v-model="policyHolderInfo.companyAddress" style="background-color: #F5F7FA;" ></textarea>
            </div>
          </li>
          <li class="address">
            <div class="tit">
              <span class="must">*</span>
              <span>通讯地址：</span>
            </div>
            <div class="sInfo">
                  <textarea maxlength="200" placeholder="请填写通讯地址"
                            v-model="policyHolderInfo.address" style="background-color: #F5F7FA;" ></textarea>
            </div>
          </li>
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>联系人：</span>
            </div>
            <div class="sInfo" >
              <input type="text" placeholder="请输入联系人"  v-model="policyHolderInfo.name">
            </div>
          </li>
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>手机号：</span>
            </div>
            <div class="sInfo">
              <input type="text" onkeyup="value=value.replace(/[^\d]/g,'')" oninput="if(value.length>11)value=value.slice(0,11)" v-model="policyHolderInfo.mobile" placeholder="请输入手机号" />
            </div>
          </li>
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>电子邮箱：</span>
            </div>
            <div class="sInfo">
              <input type="email" v-model="policyHolderInfo.email" placeholder="请输入电子邮箱" />
            </div>
          </li>
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>是否为被保险人：</span>
            </div>
            <div class="sInfo" >
              <el-radio v-model="isInsured" label="是">是</el-radio>
              <el-radio v-model="isInsured" label="否">否</el-radio>
            </div>
          </li>
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>是否存在共同被保险人：</span>
            </div>
            <div class="sInfo" >
              <el-radio v-model="isCommonInsured" label="是">是</el-radio>
              <el-radio v-model="isCommonInsured" label="否">否</el-radio>
            </div>
          </li>
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>共同被保险人保险手续办理方式：</span>
            </div>
            <div class="sInfo" >
              <el-radio v-model="commonInsuredProcessType" label="统一办理">统一办理</el-radio>
              <el-radio v-model="commonInsuredProcessType" label="各自独立办理">各自独立办理</el-radio>
            </div>
          </li>
        </ul>

        <div class="processProcedure" id="node-2" style="width: 20rem;">
          <div class="unit">
            <span>02</span>
            <span>被保险人基本信息</span>
          </div>
        </div>
        <ul class="beInsureInfo">
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>公司名称：</span>
            </div>
            <div class="sInfo" >
              <input type="text" placeholder="请输入公司中文名称"  v-model="insuredUserInfo.name">
            </div>
            <div class="sInfo" >
              <input type="text" placeholder="请输入公司英文名称(选填)" onKeyUp="value=value.replace(/[\W]/g,'')" v-model="insuredEnglishName">
            </div>
          </li>
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>注册资本：</span>
            </div>
            <div class="sInfo" >
              <input type="text" onKeyUp="value=value.replace(/^[0]+[0-9]*$/gi, '').replace(/[^\d]/g, '') " placeholder="请输入注册资本" v-model="registeredAmout">
            </div>
          </li>
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>统一社会信用代码：</span>
            </div>
            <div class="sInfo" >
              <input type="text" onKeyUp="value=value.replace(/[\W]/g,'')" @input="ownerIdnumberInput" placeholder="请输入统一社会信用代码"  v-model="insuredUserInfo.idnumber">
            </div>
          </li>
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>成立时间：</span>
            </div>
            <div class="sInfo dateSelector">
              <el-date-picker
                v-model="insuredUserInfo.brithday"
                :picker-options="brithdayDisable"
                value-format="yyyy-MM-dd"
                type="date"
                format="yyyy 年 MM 月 dd 日"
                align="center"
                placeholder="请选择成立时间"
                class="my-el-date-picker"
                :editable="false"
              >
              </el-date-picker>
            </div>
          </li>
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>法定代表人：</span>
            </div>
            <div class="sInfo" >
              <input type="text" placeholder="请输入法定代表人"  v-model="legalRepresentative">
            </div>
          </li>
          <li class="address">
            <div class="tit">
              <span class="must">*</span>
              <span>注册地址：</span>
            </div>
            <div class="sInfo">
                  <textarea maxlength="200" placeholder="请填写您的注册地址"
                            v-model="registryAddress" style="background-color: #F5F7FA;" ></textarea>
            </div>
          </li>
          <li class="address">
            <div class="tit">
              <span class="must">*</span>
              <span>通讯地址：</span>
            </div>
            <div class="sInfo">
                  <textarea maxlength="200" placeholder="请填写您的通讯地址"
                            v-model="contactAddress" style="background-color: #F5F7FA;" ></textarea>
            </div>
          </li>
          <li>
            <div class="tit">
              <span>邮政编码：</span>
            </div>
            <div class="sInfo" >
              <input type="text" placeholder="请输入邮政编码"  v-model="policyHolderInfo.postcode" oninput="if(value.length>6)value=value.slice(0,6)" onkeyup="value=value.replace(/[^\d]/g,'')">
            </div>
          </li>
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>公司性质：</span>
            </div>
            <div class="sInfo" >
              <el-radio v-model="companyNature" label="国有企业">国有企业</el-radio>
              <el-radio v-model="companyNature" label="民营企业">民营企业</el-radio>
              <el-radio v-model="companyNature" label="外资企业">外资企业</el-radio>
              <el-radio v-model="companyNature" label="其他">其他</el-radio>
            </div>
            <div class="sInfo" v-show="companyNature == '其他'">
              <input type="text" placeholder="请输入公司性质" v-model="companyNatureOther">
            </div>
          </li>
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>经营性质：</span>
            </div>
            <div class="sInfo" >
              <el-radio v-model="businessNature" label="生产性企业">生产性企业</el-radio>
              <el-radio v-model="businessNature" label="贸易公司">贸易公司</el-radio>
              <el-radio v-model="businessNature" label="贸易代理">贸易代理</el-radio>
              <el-radio v-model="businessNature" label="服务业">服务业</el-radio>
            </div>
          </li>
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>经营范围：</span>
            </div>
            <div class="sInfo" >
              <input type="text" placeholder="请输入经营范围"  v-model="businessScope">
            </div>
          </li>
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>所属行业：</span>
            </div>
            <div class="sInfo" >
              <input type="text" placeholder="请输入所属行业"  v-model="industryValue">
            </div>
          </li>
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>是否上市：</span>
            </div>
            <div class="sInfo" >
              <el-radio v-model="isOnMarket" label="是">是</el-radio>
              <el-radio v-model="isOnMarket" label="否">否</el-radio>
            </div>
          </li>
          <li v-show="isOnMarket == '是'">
            <div class="tit">
              <span class="must">*</span>
              <span>上市地点：</span>
            </div>
            <div class="sInfo" >
              <input type="text" placeholder="请输入上市地点"  v-model="onMarketPlace">
            </div>
          </li>
          <li v-show="isOnMarket == '是'">
            <div class="tit">
              <span class="must">*</span>
              <span>上市年份：</span>
            </div>
            <div class="sInfo dateSelector">
              <el-date-picker
                v-model="onMarketYear"
                :picker-options="onMarketYearDisable"
                value-format="yyyy"
                type="year"
                format="yyyy 年"
                align="center"
                placeholder="请选择上市年份"
                class="my-el-date-picker"
                :editable="false"
              >
              </el-date-picker>
            </div>
          </li>
        </ul>

        <div class="processProcedure" id="node-3" style="width: 13rem;">
          <div class="unit">
            <span>03</span>
            <span>投保意向</span>
          </div>
        </div>
        <ul class="beInsureInfo">
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>拟投保业务：</span>
            </div>
            <div class="sInfo" >
              <input type="text" placeholder="请输入拟投保业务"  v-model="businessInsured">
            </div>
          </li>
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>拟投保业务类型：</span>
            </div>
            <div class="sInfo" >
              <el-radio v-model="businessType" label="货物">货物</el-radio>
              <el-radio v-model="businessType" label="服务">服务</el-radio>
            </div>
          </li>
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>是否全部业务投保：</span>
            </div>
            <div class="sInfo" >
              <el-radio v-model="isAllBusinessInsured" label="是">是</el-radio>
              <el-radio v-model="isAllBusinessInsured" label="否">否</el-radio>
            </div>
          </li>
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>拟投保业务开始年份：</span>
            </div>
            <div class="sInfo dateSelector">
              <el-date-picker
                v-model="businessInsuredYear"
                :picker-options="businessInsuredYearDisable"
                value-format="yyyy"
                type="year"
                format="yyyy 年"
                align="center"
                placeholder="请选择拟投保业务开始年份"
                class="my-el-date-picker"
                :editable="false"
              >
              </el-date-picker>
            </div>
          </li>
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>预计未来12个月投保业务规模：</span>
            </div>
            <div class="sInfo" >
              <input type="text" placeholder="请输入预计未来12个月投保业务规模"  v-model="businessScale">
            </div>
          </li>
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>目前或过去是否已有国内贸易信用保险保单或保理安排：</span>
            </div>
            <div class="sInfo" >
              <el-radio v-model="isInsuredPolicy" label="是">是</el-radio>
              <el-radio v-model="isInsuredPolicy" label="否">否</el-radio>
            </div>
          </li>
          <li v-show="isInsuredPolicy == '是'">
            <div class="tit">
              <span class="must">*</span>
              <span>保险/保理公司名称：</span>
            </div>
            <div class="sInfo" >
              <input type="text" placeholder="请输入保险/保理公司名称"  v-model="lastInsuredComName">
            </div>
          </li>
          <li v-show="isInsuredPolicy == '是'">
            <div class="tit">
              <span class="must">*</span>
              <span>最近保险合同到期日：</span>
            </div>
            <div class="sInfo dateSelector">
              <el-date-picker
                v-model="lastInsuredExpireDate"
                value-format="yyyy-MM-dd"
                type="date"
                format="yyyy 年 MM 月 dd 日"
                align="center"
                placeholder="请选择最近保险合同到期日"
                class="my-el-date-picker"
                :editable="false"
              >
              </el-date-picker>
            </div>
          </li>
        </ul>

        <div class="processProcedure" id="node-4" style="width: 22rem;">
          <div class="unit">
            <span>04</span>
            <span>被保险人联系人信息</span>
          </div>
        </div>
        <ul class="beInsureInfo">
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>联系人：</span>
            </div>
            <div class="sInfo" >
              <input type="text" placeholder="请输入联系人"  v-model="linkerName">
            </div>
          </li>
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>联系人手机号：</span>
            </div>
            <div class="sInfo">
              <input type="text" onkeyup="value=value.replace(/[^\d]/g,'')" oninput="if(value.length>11)value=value.slice(0,11)" placeholder="请输入联系人手机号" class="phone" v-model="linkerPhone">
            </div>
          </li>
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>联系人电子邮箱：</span>
            </div>
            <div class="sInfo">
              <input type="email" v-model="linkerMail" placeholder="请输入联系人电子邮箱" />
            </div>
          </li>
          <li>
            <div class="tit">
              <span>联系人职务：</span>
            </div>
            <div class="sInfo" >
              <input type="text" placeholder="请输入联系人职务"  v-model="linkerJob">
            </div>
          </li>
          <li>
            <div class="tit">
              <span>联系人传真：</span>
            </div>
            <div class="sInfo" >
              <input type="text" placeholder="请输入联系人传真"  v-model="linkerFax">
            </div>
          </li>

          <li>
            <div class="tit">
              <span>代理人：</span>
            </div>
            <div class="sInfo" >
              <input type="text" placeholder="请输入联系人"  v-model="agentName">
            </div>
          </li>
          <li>
            <div class="tit">
              <span>代理人手机号：</span>
            </div>
            <div class="sInfo">
              <input type="text" onkeyup="value=value.replace(/[^\d]/g,'')" oninput="if(value.length>11)value=value.slice(0,11)" placeholder="请输入代理人手机号" class="phone" v-model="agentPhone">
            </div>
          </li>
          <li>
            <div class="tit">
              <span>代理人电子邮箱：</span>
            </div>
            <div class="sInfo">
              <input type="email" v-model="agentMail" placeholder="请输入代理人电子邮箱" />
            </div>
          </li>
          <li>
            <div class="tit">
              <span>代理人职务：</span>
            </div>
            <div class="sInfo" >
              <input type="text" placeholder="请输入代理人职务"  v-model="agentJob">
            </div>
          </li>
          <li>
            <div class="tit">
              <span>代理人传真：</span>
            </div>
            <div class="sInfo" >
              <input type="text" placeholder="请输入代理人传真"  v-model="agentFax">
            </div>
          </li>
        </ul>

        <div class="processProcedure" id="node-5" style="width: 13rem;">
          <div class="unit">
            <span>05</span>
            <span>上传证件</span>
          </div>
        </div>
        <div class="insuran-con uploadInfo">
          <span class="topTips">请把身份证从保护套里拿出来拍照，以免反光影响信息采集的正确率。</span>
          <div class="contentList">
            <div class="content">
              <div class="title">请选择上传身份证人脸面</div>
              <div class="exampleUnit">
                <div class="example">
                  <img id="idCardFront" src="../../../../static/images/public/autoInsurance/idCard-1.png" />
                </div>
                <div class="upload">
                  <input type="file" @change="selectIdCardFront" ref="idCardFront" />
                </div>
              </div>
            </div>
            <div class="content">
              <div class="title">请选择上传身份证国徽面</div>
              <div class="exampleUnit">
                <div class="example">
                  <img id="idCardBack" src="../../../../static/images/public/autoInsurance/idCard-2.png" />
                </div>
                <div class="upload">
                  <input type="file" @change="selectIdCardBack" ref="idCardBack" />
                </div>
              </div>
            </div>

          </div>
          <div class="contentList">
            <div class="content">
              <div class="title">请选择上传营业执照</div>
              <div class="exampleUnit">
                <div class="example">
                  <img id="busLicense" src="../../../../static/images/public/businessLicenseExample.jpg" />
                </div>
                <div class="upload">
                  <input type="file" @change="selectBusLicense" ref="busLicense" />
                </div>
              </div>
            </div>
            <div class="content">
              <div class="title">请选择其他附件</div>
              <div class="exampleUnit">
                <div class="example">
                  <img id="otherFile" src="../../../../static/images/public/otherFile.png" style="height: 10rem;" alt="" />
                </div>
                <div class="upload">
                  <input type="file" @change="selectOtherFile" ref="otherFile" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="submitOrder">
          <el-button @click="insureOrder" class="header-button-order-add">立即投保</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      name: "domesticTradeCredit_insureInfo",
      data() {
        return {
          insuranceInfoId: "100476",
          planId: "1803",
          sellProductId: "1015082",
          beShareToken: "",
          orderToken: "",                   // 订单Token
          startDate: "",                    // 起保时间
          endDate: "",                      // 终保时间
          skuId: "14390",                   // skuId
          eventLogToken: "",                // 事件日志Token
          day_tips: "",                     // 天数相关 -> Id标识
          fixedOptionOfOneYear: "",         // 保障期限固定一年 -> [true: 固定, false: 按销售产品]
          guaranteePeriod: "",              // 保障期限数据源

          // 投保人信息
          policyHolderInfo:{
            companyName: "",                // 投保人名称
            companyAddress: "",             // 投保人注册地址
            address: "",                    // 投保人通讯地址
            name: "",                       // 投保人联系人
            mobile: "",                     // 投保人手机号
            email: "",                      // 投保人电子邮箱
            idnumber: "",                   // 投保人统一社会信用代码
            postcode: "",                   // 邮政编码
          },
          isInsured: "",                    // 是否为被保险人
          isCommonInsured: "",              // 是否存在共同被保险人
          commonInsuredProcessType: "",     // 共同被保险人保险手续办理方式
          // 被保人信息
          insuredUserInfo: {
            name: "",                       // 被保人名称
            idnumber: "",                   // 被保人统一社会信用代码
            brithday: "",                   // 成立时间
          },
          brithdayDisable: {                // 过户日期 - 期限
            disabledDate(time) {
              const date = new Date(Date.now());
              return time.getTime() > new Date(date - 1 * 24 * 60 * 60 * 1000);
            },
          },
          insuredEnglishName: "",           // 公司英文名称
          legalRepresentative: "",          // 法定代表人
          registeredAmout: "",              // 注册资本
          registryAddress: "",              // 被保人注册地址
          contactAddress: "",               // 被保人通讯地址
          companyNature: "",                // 公司性质
          companyNatureOther: "",           // 公司性质 - 其他
          businessNature: "",               // 经营性质
          businessScope: "",                // 经营范围
          industryValue: "",                // 所属行业
          isOnMarket: "",                   // 是否上市
          onMarketPlace: "",                // 上市地点
          onMarketYear: "",                 // 上市年份
          onMarketYearDisable: {            // 拟投保业务开始年份 - 期限
            disabledDate(time) {
              const date = new Date(Date.now());
              return time.getTime() > new Date(date - 1 * 24 * 60 * 60 * 1000);
            },
          },
          businessInsured: "",              // 拟投保业务
          businessType: "",                 // 拟投保业务类型
          isAllBusinessInsured: "",         // 是否全部业务投保
          businessInsuredYear: "",          // 拟投保业务开始年份
          businessInsuredYearDisable: {            // 拟投保业务开始年份 - 期限
            disabledDate(time) {
              const date = new Date(Date.now());
              return time.getTime() > new Date(date - 1 * 24 * 60 * 60 * 1000);
            },
          },
          businessScale: "",                // 预计未来12个月投保业务规模
          isInsuredPolicy: "",              // 目前或过去是否已有国内贸易信用保险保单或保理安排
          lastInsuredComName: "",           // 保险/保理公司名称
          lastInsuredExpireDate: "",        // 最近保险合同到期日

          // 被保险人联系人信息
          linkerName: "",                   // 联系人
          linkerJob: "",                    // 联系人职务
          linkerPhone: "",                  // 联系人手机号
          linkerFax: "",                    // 联系人传真
          linkerMail: "",                   // 联系人电子邮件
          agentName: "",                    // 代理人
          agentJob: "",                     // 代理人职务
          agentPhone: "",                   // 代理人手机号
          agentFax: "",                     // 代理人传真
          agentMail: "",                    // 代理人电子邮件

          idCardFront: "",                  // 身份证 - 人像面照片
          idCardBack: "",                   // 身份证 - 国徽面照片
          busLicense: "",                   // 营业执照
          otherFile: "",                    // 其他附件

          formDataList: {},                 // 已选上传图片集合
        };
      },
      methods: {
        // 立即投保所需的数据
        findInsuranceNeedData(){
          let that = this;
          that.$$.request({
            url: that.UrlConfig.insuranceInfo_detail_immediatelyData,
            pars: {
              productId: that.insuranceInfoId,
              sellProductId: that.sellProductId,
            },
            loading: true,
            sfn: function (data) {
              that.$$.closeLoading();
              if (data.success) {
                let {startingTimeOfInsurance, guaranteePeriodData, day_tips, fixedOptionOfOneYear} = data;

                let maxSelectDate = new Date();
                maxSelectDate.setFullYear(maxSelectDate.getFullYear() + 1);
                maxSelectDate = that.$$.dateFormat(maxSelectDate, "yyyy-MM-dd");

                that.startDate = startingTimeOfInsurance;
                that.endDate = maxSelectDate;
                that.guaranteePeriod = guaranteePeriodData[0].id;
                that.day_tips = day_tips;
                that.fixedOptionOfOneYear = fixedOptionOfOneYear;
              }
            },
            ffn: function (data) {
              that.$$.errorHandler();
            }
          });
        },
        // 统一社会信用代码
        ownerIdnumberInput(e){
          let that = this,
            value = e.target.value;

          // 同步 投保人证件号码
          that.policyHolderInfo.idnumber = value;
        },
        selectIdCardFront(){
          let file = this.$refs.idCardFront.files[0];

          this.compressImages(file, 'idCardFront', "20016");
        },
        selectIdCardBack(){
          let file = this.$refs.idCardBack.files[0];

          this.compressImages(file, 'idCardBack', "20016");
        },
        selectBusLicense(){
          let file = this.$refs.busLicense.files[0];

          this.compressImages(file, 'busLicense', "20016");
        },
        selectOtherFile(){
          let file = this.$refs.otherFile.files[0];

          this.compressImages(file, 'otherFile', "20022");
        },
        //-- 压缩图片
        compressImages(file, id, formType) {
          let that = this;

          //-- file>2M照片压缩到2M，file<=2M不压缩 （半身正面照片压缩到200K）
          that.imageConversion.compressAccurately(file, 2048).then(res => {
            res = new File([res], file.name, {type: res.type, lastModified: Date.now()});

            let reader = new FileReader();
            reader.readAsDataURL(res);
            reader.onload = function(event) {
              let base64 = event.target.result;


              if (file.type == 'image/png' || file.type == 'image/jpeg') {
                $(`#${id}`).attr({"src": base64, "alt": file.name});
              }else {
                $(`#${id}`).attr({"src": '', "alt": file.name});
              }
            };

            let formData = new window.FormData(),
              cardSide = '0';
            formData.append("file", res);
            formData.append("formType", formType);
            if (id == 'drivingPermitBack') cardSide = '1';
            formData.append("cardSide", cardSide );
            that.formDataList[id] = formData;

            // if (id == 'otherFile') return;

            // 上传识别
            // that.fileUploadHandler(id);
          });
        },
        // 文件上传 - 识别
        fileUploadHandler(id){
          let that = this,
            formData = that.formDataList[id];

          let formType = formData.get('formType');

          that.$$.loading("识别中...");
          that.$$.request({
            url: that.UrlConfig.upload_attachment_uploadFileByComplex,
            pars: formData,
            requestBody: true,
            sfn: function (data) {
              that.$$.closeLoading();

              const { success, msg, datas } = data;
              if (success) {
                switch (formType) {
                  case '30001':{
                    responseHandler_30001(datas, id);
                    break;
                  }
                  case '30002':{
                    responseHandler_30002(datas, id);
                    break;
                  }
                }
              } else {
                that.$message.error(msg);
                that.formDataList[id] = null;
              }
            },
            ffn: function (data) {
              that.$$.errorHandler();
            }
          });
          // 身份证识别 -> 响应处理
          function responseHandler_30001(data, id){
            that.$message.success("识别成功！");
            that.busLicense = data.oss.filePath;
          }
          // 身份证识别 -> 响应处理
          function responseHandler_30002(data, id){
            const { idCardNumber } = data;

            if (id == 'idCardFront'){
              if(that.$$.isValidObj(idCardNumber)){
                that.$message.success("识别成功！");
              }else{
                that.$message.error("未识别到证件号，请重试！");
                that.formDataList[id] = null;
              }
            }else if(id == 'idCardBack'){
              if(that.$$.isValidObj(idCardNumber)){
                that.$message.error("请选择上传身份证国徽面！");
                that.formDataList[id] = null;
              }else {
                that.$message.success("识别成功！");
              }
            }
          }
        },
        // 立即投保 - 参数处理
        insureOrder() {
          let that = this;

          // 字段校验
          const errorMsgList = that.dataIsValid();
          if(that.$$.isValidObj(errorMsgList) && that.$$.isValidObj(errorMsgList.errorMsg)) {
            document.getElementById(errorMsgList.id).scrollIntoView();
            return that.$message.error(errorMsgList.errorMsg);
          }

          // 数据拼接
          let params = that.quoteMainData();
          if (params != false) that.immediateInsurance(params);

        },
        //-- //-- 投保校验
        immediateInsurance(params){
          let that = this;
          let lists = {
            productId: that.insuranceInfoId,
            sellProductId: that.guaranteePeriod,
            groupSellId: that.sellProductId,
            startDate: that.startDate,
            endDate: that.endDate,
            orderToken: that.orderToken,
            beShareToken: that.beShareToken,
            eventLogToken: that.eventLogToken,
            terminal: "27",
            skuId: that.skuId,
            day_tips: that.day_tips,
            fixedOptionOfOneYear: that.fixedOptionOfOneYear,
            occupationDisplay: false,
            occupationTitle: "",
            productConditionTitle: "",
          };

          that.$$.request({
            url: that.UrlConfig.insuranceInfo_detail_immediateInsurance,
            pars: lists,
            loading: true,
            requestBody: true,
            sfn: function (data) {
              that.$$.closeLoading();
              if (data.success) {
                const { _orderSignKey } = data;
                lists["_orderSignKey"] = _orderSignKey;

                that.orderHandler(lists, params);
              }
            },
            ffn: function (data) {
              that.$$.errorHandler();
            }
          });
        },
        orderHandler(list, params){
          let that = this;
          that.$$.request({
            url: that.UrlConfig.insuranceInfo_orderHandler,
            pars: list,
            loading: true,
            requestBody: true,
            sfn: function (data) {
              that.$$.closeLoading();
              if (data.success) {
                const {orderToken} = data.datas;
                that.orderToken = orderToken;
                params["orderToken"] = orderToken;

                that.submitOrderHandler(params);
              }
            },
            ffn: function (data) {
              that.$$.errorHandler();
            }
          });
        },
        // 立即投保
        submitOrderHandler(params){
          let that = this;
          that.$$.request({
            url: that.UrlConfig.insuranceInfo_submitOrderHandler,
            pars: params,
            loading: true,
            requestBody: true,
            sfn: function (data) {
              that.$$.closeLoading();
              if (data.success) {
                let datas = { orderToken: that.orderToken, beShareToken: that.beShareToken, eventLogToken: that.eventLogToken };

                that.$router.push({path: '/domesticTradeCredit/orderDetail', query: datas});
              }
            },
            ffn: function (data) {
              that.$$.errorHandler();
            }
          });
        },
        // 字段校验
        dataIsValid(){
          let that = this,
            reg_creditCode = /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g,                                         // 统一社会信用代码正则
            reg_mobile = /^(13[0-9]|14[01456879]|15[0-3,5-9]|16[2567]|17[0-8]|18[0-9]|19[0-3,5-9])\d{8}$/,          // 11位手机号码正则
            reg_phone = /^(0\d{2,3})-?(\d{7,8})$/,                                                                  // 座机号码正则
            emailReg = /^([a-zA-Z0-9_\.\-])+[\@,\＠](([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;                     // 电子邮箱正则

          const {
            // 投保人信息
            policyHolderInfo,
            isInsured,                    // 是否为被保险人
            isCommonInsured,              // 是否存在共同被保险人
            commonInsuredProcessType,     // 共同被保险人保险手续办理方式

            // 被保人信息
            insuredUserInfo,

            legalRepresentative,          // 法定代表人
            registeredAmout,              // 注册资本
            registryAddress,              // 被保人注册地址
            contactAddress,               // 被保人通讯地址
            companyNature,                // 公司性质
            companyNatureOther,           // 公司性质 - 其他
            businessNature,               // 经营性质
            businessScope,                // 经营范围
            industryValue,                // 所属行业
            isOnMarket,                   // 是否上市
            onMarketPlace,                // 上市地点
            onMarketYear,                 // 上市年份
            businessInsured,              // 拟投保业务
            businessType,                 // 拟投保业务类型
            isAllBusinessInsured,         // 是否全部业务投保
            businessInsuredYear,          // 拟投保业务开始年份
            businessScale,                // 预计未来12个月投保业务规模
            isInsuredPolicy,              // 目前或过去是否已有国内贸易信用保险保单或保理安排
            lastInsuredComName,           // 保险/保理公司名称
            lastInsuredExpireDate,        // 最近保险合同到期日

            // 被保险人联系人信息
            linkerName,                   // 联系人
            linkerPhone,                  // 联系人手机号
            linkerMail,                   // 联系人电子邮件

            formDataList,                 // 已选上传图片集合
          } = that;

          // 投保人信息
          if(!this.$$.isValidObj(policyHolderInfo.companyName)) return {errorMsg: "投保人名称不能为空~", id: 'node-1'};
          if(!this.$$.isValidObj(policyHolderInfo.companyAddress)) return {errorMsg: "投保人注册地址不能为空~", id: 'node-1'};
          if(!this.$$.isValidObj(policyHolderInfo.address)) return {errorMsg: "投保人通讯地址不能为空~", id: 'node-1'};
          if(!this.$$.isValidObj(policyHolderInfo.name)) return {errorMsg: "投保人联系人不能为空~", id: 'node-1'};
          if(!this.$$.isValidObj(policyHolderInfo.mobile)) return {errorMsg: "投保人手机号不能为空~", id: 'node-1'};
          if(!reg_mobile.test(policyHolderInfo.mobile)) return {errorMsg: "请输入正确的投保人手机号~", id: 'node-1'};
          if(!this.$$.isValidObj(policyHolderInfo.email)) return {errorMsg: "投保人电子邮箱不能为空~", id: 'node-1'};
          if(!emailReg.test(policyHolderInfo.email)) return {errorMsg: "请输入正确的投保人电子邮箱~", id: 'node-1'};
          if(!this.$$.isValidObj(isInsured)) return {errorMsg: "请选择是否为被保险人~", id: 'node-1'};
          if(!this.$$.isValidObj(isCommonInsured)) return {errorMsg: "请选择是否存在共同被保险人~", id: 'node-1'};
          if(!this.$$.isValidObj(commonInsuredProcessType)) return {errorMsg: "请选择共同被保险人保险手续办理方式~", id: 'node-1'};

          // 被保险人基本信息
          if(!this.$$.isValidObj(insuredUserInfo.name)) return {errorMsg: "公司名称不能为空~", id: 'node-2'};
          if(!this.$$.isValidObj(registeredAmout)) return {errorMsg: "注册资本不能为空~", id: 'node-2'};
          if(!this.$$.isValidObj(insuredUserInfo.idnumber)) return {errorMsg: "统一社会信用代码不能为空~", id: 'node-2'};
          if(!reg_creditCode.test(insuredUserInfo.idnumber)) return {errorMsg: "请输入正确的统一社会信用代码~", id: 'node-2'};
          if(!this.$$.isValidObj(insuredUserInfo.brithday)) return {errorMsg: "请选择成立时间~", id: 'node-2'};
          if(!this.$$.isValidObj(legalRepresentative)) return {errorMsg: "法定代表人不能为空~", id: 'node-2'};
          if(!this.$$.isValidObj(registryAddress)) return {errorMsg: "注册地址不能为空~", id: 'node-2'};
          if(!this.$$.isValidObj(contactAddress)) return {errorMsg: "通讯地址不能为空~", id: 'node-2'};
          if(!this.$$.isValidObj(companyNature)) return {errorMsg: "请选择公司性质~", id: 'node-2'};
          if(companyNature == '其他' && !this.$$.isValidObj(companyNatureOther)) return {errorMsg: "请输入公司性质~", id: 'node-2'};
          if(!this.$$.isValidObj(businessNature)) return {errorMsg: "请选择经营性质~", id: 'node-2'};
          if(!this.$$.isValidObj(businessScope)) return {errorMsg: "经营范围不能为空~", id: 'node-2'};
          if(!this.$$.isValidObj(industryValue)) return {errorMsg: "所属行业不能为空~", id: 'node-2'};
          if(!this.$$.isValidObj(isOnMarket)) return {errorMsg: "请选择是否上市~", id: 'node-2'};
          if(isOnMarket == '是' && !this.$$.isValidObj(onMarketPlace)) return {errorMsg: "请输入上市地点~", id: 'node-2'};
          if(isOnMarket == '是' && !this.$$.isValidObj(onMarketYear)) return {errorMsg: "请输入上市年份~", id: 'node-2'};

          // 投保意向
          if(!this.$$.isValidObj(businessInsured)) return {errorMsg: "拟投保业务不能为空~", id: 'node-3'};
          if(!this.$$.isValidObj(businessType)) return {errorMsg: "请选择拟投保业务类型~", id: 'node-3'};
          if(!this.$$.isValidObj(isAllBusinessInsured)) return {errorMsg: "请选择是否全部业务投保~", id: 'node-3'};
          if(!this.$$.isValidObj(businessInsuredYear)) return {errorMsg: "请选择拟投保业务开始年份~", id: 'node-3'};
          if(!this.$$.isValidObj(businessScale)) return {errorMsg: "预计未来12个月投保业务规模不能为空~", id: 'node-3'};
          if(!this.$$.isValidObj(isInsuredPolicy)) return {errorMsg: "请选择目前或过去是否已有国内贸易信用保险保单或保理安排~", id: 'node-3'};
          if(isInsuredPolicy == '是' && !this.$$.isValidObj(lastInsuredComName)) return {errorMsg: "请输入保险/保理公司名称~", id: 'node-3'};
          if(isInsuredPolicy == '是' && !this.$$.isValidObj(lastInsuredExpireDate)) return {errorMsg: "请选择最近保险合同到期日~", id: 'node-3'};

          // 被保险人联系人信息
          if(!this.$$.isValidObj(linkerName)) return {errorMsg: "联系人不能为空~", id: 'node-4'};
          if(!this.$$.isValidObj(linkerPhone)) return {errorMsg: "联系人手机号不能为空~", id: 'node-4'};
          if(!reg_mobile.test(linkerPhone)) return {errorMsg: "请输入正确的联系人手机号~", id: 'node-4'};
          if(!this.$$.isValidObj(linkerMail)) return {errorMsg: "联系人电子邮箱不能为空~", id: 'node-4'};
          if(!emailReg.test(linkerMail)) return {errorMsg: "请输入正确的投保人电子邮箱~", id: 'node-4'};

          // 上传证件
          if(!this.$$.isValidObj(formDataList.idCardFront)) return {errorMsg: "请选择上传身份证人脸面~", id: 'node-5'};
          if(!this.$$.isValidObj(formDataList.idCardBack)) return {errorMsg: "请选择上传身份证国徽面~", id: 'node-5'};
          if(!this.$$.isValidObj(formDataList.busLicense)) return {errorMsg: "请选择上传营业执照~", id: 'node-5'};
          if(!this.$$.isValidObj(formDataList.otherFile)) return {errorMsg: "请选择上传其他附件~", id: 'node-5'};
        },
        //-- 数据拼接
        quoteMainData() {
          let that = this;
          const {
            orderToken,                   // 订单Token
            sellProductId,                // 展示产品Id
            startDate,                    // 起保时间
            endDate,                      // 终保时间
            beShareToken,                 // 分享Token
            skuId,                        // skuId

            // 投保人信息
            policyHolderInfo,
            isInsured,                    // 是否为被保险人
            isCommonInsured,              // 是否存在共同被保险人
            commonInsuredProcessType,     // 共同被保险人保险手续办理方式

            // 被保人信息
            insuredUserInfo,

            insuredEnglishName,           // 公司英文名称
            legalRepresentative,          // 法定代表人
            registeredAmout,              // 注册资本
            registryAddress,              // 被保人注册地址
            contactAddress,               // 被保人通讯地址
            companyNature,                // 公司性质
            companyNatureOther,           // 公司性质 - 其他
            businessNature,               // 经营性质
            businessScope,                // 经营范围
            industryValue,                // 所属行业
            isOnMarket,                   // 是否上市
            onMarketPlace,                // 上市地点
            onMarketYear,                 // 上市年份
            businessInsured,              // 拟投保业务
            businessType,                 // 拟投保业务类型
            isAllBusinessInsured,         // 是否全部业务投保
            businessInsuredYear,          // 拟投保业务开始年份
            businessScale,                // 预计未来12个月投保业务规模
            isInsuredPolicy,              // 目前或过去是否已有国内贸易信用保险保单或保理安排
            lastInsuredComName,           // 保险/保理公司名称
            lastInsuredExpireDate,        // 最近保险合同到期日

            // 被保险人联系人信息
            linkerName,                   // 联系人
            linkerPhone,                  // 联系人手机号
            linkerMail,                   // 联系人电子邮件
            linkerJob,                    // 联系人职务
            linkerFax,                    // 联系人传真
            agentName,                    // 代理人
            agentJob,                     // 代理人职务
            agentPhone,                   // 代理人手机号
            agentFax,                     // 代理人传真
            agentMail,                    // 代理人电子邮件

            // 上传证件
            idCardFront,                  // 身份证 - 人像面照片
            idCardBack,                   // 身份证 - 国徽面照片
            busLicense,                   // 营业执照
            otherFile,                    // 其他附件
          } = that;

          // -- 主数据
          let params = {
            //-- 订单Token
            orderToken,
            //-- 产品期限
            sellProductId,
            //-- 起保时间
            startDate,
            //-- 终保时间
            endDate,
            //-- 分享Token
            beShareToken,
            //-- skuId
            skuId,

          };
          let extendList = [];

          // 上传 身份证照片
          if (!that.$$.isValidObj(that.idCardFront)) {
            that.fileUpload('idCardFront');
            return false;
          }

          // 额外字段
          extendList.push({
            isInsured,                    // 是否为被保险人
            isCommonInsured,              // 是否存在共同被保险人
            commonInsuredProcessType,     // 共同被保险人保险手续办理方式

            legalRepresentative,          // 法定代表人
            registeredAmout,              // 注册资本
            registryAddress,              // 被保人注册地址
            contactAddress,               // 被保人通讯地址
            companyNature,                // 公司性质
            businessNature,               // 经营性质
            businessScope,                // 经营范围
            industryValue,                // 所属行业
            isOnMarket,                   // 是否上市
            businessInsured,              // 拟投保业务
            businessType,                 // 拟投保业务类型
            isAllBusinessInsured,         // 是否全部业务投保
            businessInsuredYear,          // 拟投保业务开始年份
            businessScale,                // 预计未来12个月投保业务规模
            isInsuredPolicy,              // 目前或过去是否已有国内贸易信用保险保单或保理安排

            // 被保险人联系人信息
            linkerName,                   // 联系人
            linkerPhone,                  // 联系人手机号
            linkerMail,                   // 联系人电子邮件
          });

          if (companyNature == '其他'){
            extendList.push({
              companyNature: companyNature + '-' + companyNatureOther,           // 公司性质 - 其他
            });
          }

          if (isOnMarket == '是'){
            extendList.push({
              onMarketPlace,                // 上市地点
              onMarketYear,                 // 上市年份
            });
          }

          if (isInsuredPolicy == '是'){
            extendList.push({
              lastInsuredComName,           // 保险/保理公司名称
              lastInsuredExpireDate,        // 最近保险合同到期日
            });
          }

          if (that.$$.isValidObj(insuredEnglishName)) extendList.push({insuredEnglishName});
          if (that.$$.isValidObj(linkerJob)) extendList.push({linkerJob});
          if (that.$$.isValidObj(linkerFax)) extendList.push({linkerFax});
          if (that.$$.isValidObj(agentName)) extendList.push({agentName});
          if (that.$$.isValidObj(agentJob)) extendList.push({agentJob});
          if (that.$$.isValidObj(agentPhone)) extendList.push({agentPhone});
          if (that.$$.isValidObj(agentFax)) extendList.push({agentFax});
          if (that.$$.isValidObj(agentMail)) extendList.push({agentMail});


          extendList[0]['idCardFront'] = idCardFront; // 身份证 - 人像面照片
          extendList[0]['idCardBack'] = idCardBack;   // 身份证 - 国徽面照片
          extendList[0]['busLicense'] = busLicense;   // 营业执照
          extendList[0]['otherFile'] = otherFile;     // 其他附件

          // 投保人
          let insureData = {
            companyName: policyHolderInfo.companyName,
            address: policyHolderInfo.companyAddress,
            insureAddress: policyHolderInfo.address,
            insureName: policyHolderInfo.name,
            insurePhone: policyHolderInfo.mobile,
            insureMail: policyHolderInfo.email,
            insureCardNum: policyHolderInfo.idnumber,
            postcode: policyHolderInfo.postcode,
            type: '2',
            insureSex: "O",
            insureCardType: "6",
            insureCardTypeLabel: "统一社会信用代码",
            insureBirthday: insuredUserInfo.brithday,
          };

          // 被保人
          let insureCardType = '6';     // 证件类型（1-身份证、6-统一社会信用代码）
          const thisKey = `${insureCardType}_${insuredUserInfo.idnumber}`;
          let beInsureData = {};
          beInsureData[thisKey] = {
            insureName: insuredUserInfo.name,
            insureCardNum: insuredUserInfo.idnumber,
            insureBirthday: insuredUserInfo.brithday,
            insureSex: "O",
            insureCardType: "6",
            insureCardTypeLabel: "统一社会信用代码",
            relationship: "6",
            relationshipLabel: "其他",
            //-- 职业选择 -> [true: 显示, false: 隐藏]
            occupationDisplay: false,
          };

          //-- 数据脱敏
          (function(){
            const tips = that.$$.constant.requestRSATips;
            if(!tips) return;
            const keys = ["insureCardNum", "insurePhone", "insureMail"];

            //-- 投保人
            rsa(insureData);
            //-- 被保险人
            for(let key in beInsureData){
              rsa(beInsureData[key]);
              beInsureData[that.$$.rsaEncrypt(key)] = beInsureData[key];
              delete beInsureData[key];
            }
            function rsa(data){
              data[tips] = true;
              for(const key of keys){
                data[key] = that.$$.rsaEncrypt(data[key]);
              }
            }
          })();


          params.insureData = JSON.stringify(insureData);
          params.beInsureData = JSON.stringify(beInsureData);
          params.extendLists = JSON.stringify(extendList);

          return params;
        },
        fileUpload(id){
          let that = this;
          let formData = that.formDataList[id];

          that.$$.loading("上传中...");
          that.$$.request({
            url: that.UrlConfig.upload_attachment_upload,
            pars: formData,
            requestBody: true,
            sfn: function (data) {
              that.$$.closeLoading();

              const { success, msg, datas } = data;
              if (success) {
                if (id == 'idCardFront') {
                  that.idCardFront = datas.filePath;
                  that.fileUpload('idCardBack');
                  return false;
                }

                if (id == 'idCardBack') {
                  that.idCardBack = datas.filePath;
                  that.fileUpload('busLicense');
                  return false;
                }

                if (id == 'busLicense') {
                  that.busLicense = datas.filePath;
                  that.fileUpload('otherFile');
                  return false;
                }

                if (id == 'otherFile') {
                  that.otherFile = datas.filePath;
                }

                if (that.$$.isValidObj(that.idCardFront) && that.$$.isValidObj(that.idCardBack) && that.$$.isValidObj(that.busLicense) && that.$$.isValidObj(that.otherFile)) {
                  that.$message.success("上传成功~");

                  that.insureOrder();
                }
              } else {
                that.$message.error(msg);
              }
            },
            ffn: function (data) {
              that.$$.errorHandler();
            }
          });
        },
        // 产品屏幕录制
        recording(){
          let that = this;
          let eventLogToken = decodeURIComponent(encodeURIComponent(that.eventLogToken).replace(new RegExp("%20","gm"),"%2B"));
          if (that.$$.isValidObj(eventLogToken)) {
            that.screenRecBase.startLoad();
            that.eventLogToken = eventLogToken;
          }
        },

      },
      mounted() {
        let that = this;
        const {orderToken, beShareToken, eventLogToken} = that.$route.query;
        that.orderToken = orderToken;
        let shareToken = decodeURIComponent(encodeURIComponent(beShareToken).replace(new RegExp("%20","gm"),"%2B"));
        that.beShareToken = shareToken;
        that.eventLogToken = eventLogToken;

        that.findInsuranceNeedData();

        // 产品屏幕录制
        that.recording();
      },
    }
</script>

<style scoped>
  @import "../../../../static/css/dutyInsurance/fillInfo.css";
  .wrapper{
    padding: 20px 0;
  }

  .section{
    position: relative;
    min-width: 1000px;
    margin: 0 auto;
    padding: 2rem 5%;
    background: #FFFFFF;
    box-shadow: 0 0 1rem 0 rgba(203, 203, 203, 0.2);
  }
  .must{
    color: #FF7052;
    display: inline-block;
  }

  .customerIcon{
    width: 40px;
    height: 30px;
    background: #5677fc;
    display: inline-block;
    position: absolute;
    right: 0;
    border-radius: 20px 0 0 20px;
    top: -35px;
    z-index: 2;
  }
  .customerIcon .icon{
    background: url('../../../../static/images/public/autoInsurance/customerIcon.png') no-repeat;
    width: 21px;
    height: 18px;
    display: inline-block;
    background-size: contain;
    margin-top: 6px;
    margin-left: 12px;
  }

  .insureList,
  .beInsureInfo,
  .uploadInfo{
    padding: 3rem 0;
  }

  .insureList>li,
  .beInsureInfo>li{
    position: relative;
    width: 100%;
    height: 50px;
    padding: 5px 0;
    background-color: #fff;
    display: inline-block;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    -webkit-user-select: none;
    -moz-user-select: none;
    font-size: 13px;
  }

  .insureList>li input,
  .beInsureInfo>li input{
    width: 300px;
    height: 39px;
    padding: 0 5px;
    font-size: 14px;
    box-sizing: border-box;
    color: #ff7052;
    display: inline-block;
    outline: none;
    -webkit-appearance: none;
    -webkit-box-sizing: border-box;
    -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    border: 1px solid #DCDFE6;
    border-radius: 4px;
  }

  .section input::-webkit-input-placeholder {
    font-size: 14px!important;
  }

  .section /deep/ .el-input__inner,
  .section /deep/ .el-select,
  .section /deep/ .el-cascader{
    width: 300px;
    color: #ff7052;
  }

  .address{
    height: 66px!important;
  }
  .address .tit{
    vertical-align: middle;
  }
  .address textarea {
    outline: none;
    vertical-align: middle;
  }

  textarea{
    width: 300px;
    height: 100%;
    line-height: 150%;
    color: #FF7052;
    padding: 0.625rem;
    resize: none;
    border-radius: 0.375rem;
    border: 1px solid #c9ccd4;
  }

  .tit {
    width: 230px;
    color: #000;
    letter-spacing: 1px;
    display: inline-block;
    text-align: right;
  }

  .sInfo{
    height: 100%;
    line-height: 40px;
    color: #ff7052;
    display: inline-block;
    position: relative;
    padding-left: 0.5rem;
  }

  .submitOrder{
    width: 100%;
    margin: 20px auto;
    text-align: center;
  }

  .header-button-order-add {
    width: 20rem;
    background: #FF7052 !important;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF !important;
    margin-bottom: 25px;
  }

  .header-button-order-add:hover {
    color: #FFFFFF !important;
    background: #FF7052 !important;
  }

  /*上传证件*/
  .uploadInfo .topTips{
    color: #ff6503;
    background-color: #fbf0e2;
    padding: 5px 4%;
    margin: 10px 10px 0;
    font-size: 12px;
    display: block;
  }
  .uploadInfo .contentList{
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: space-around;
    justify-content: space-around;
    padding-bottom: 20px;
  }
  .uploadInfo .content{
    background-color: white;
    text-align: center;
  }
  .uploadInfo .content .title{
    font-size: 16px;
    margin: 30px auto 20px;
  }

  .uploadInfo .content .exampleUnit{
    width: 16rem;
    height: 10rem;
    margin: 0 auto;
    position: relative;
    overflow: hidden;
    border: 1px solid #999;
    border-radius: 1rem;
  }

  .exampleUnit .example,
  .exampleUnit .example img{
    height: 100%;
  }

  .uploadInfo .content .upload{
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
    background: #fff;
    z-index: 999;
    overflow: hidden;
  }
  .uploadInfo .content .upload>input{
    opacity: 0;
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/domesticTradeCredit/insureInfo.vue